/**
 * Only the most recently started request may write state. A response (success
 * OR error — e.g. a 403 for a previous workspace id) that arrives after a newer
 * request started, or after unmount, is ignored.
 */
export interface LatestRequestGuard {
  begin: () => number
  isCurrent: (token: number) => boolean
  invalidate: () => void
}

export function createLatestRequestGuard(): LatestRequestGuard {
  let seq = 0
  return {
    begin: () => {
      seq += 1
      return seq
    },
    isCurrent: (token) => token === seq,
    invalidate: () => {
      seq += 1
    },
  }
}
